<template>
  <NuxtLink
    class="waper-item"
    :class="[color, { flexible }]"
    :to="dragging ? undefined : `/wapers/${waper.slug}`"
    draggable="false"
  >
    <div class="img-container">
      <NuxtImg
        v-if="waper.avatar"
        :src="waper.avatar.url"
        :alt="`photo de profil de ${waper.nickname}`"
        width="168"
        height="168"
        quality="80"
        fit="cover"
        format="auto"
        draggable="false"
      />
    </div>
    <div class="text-container">
      <p class="name">
        {{ readMore(capitalize(waper.nickname), 25) }}
      </p>
      <p class="points">
        {{ waper.points_total || 0 }}
        {{ pluralize('point', waper.points_total) }}
      </p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { UserWithRoute } from '~/types'

withDefaults(
  defineProps<{
    waper: UserWithRoute
    color?: string
    flexible?: boolean
    dragging?: boolean
  }>(),
  {
    color: 'white',
    flexible: false,
    dragging: false,
  },
)
</script>

<style lang="scss" scoped>
.waper-item {
  display: flex;
  align-items: center;
  width: 35rem;
  height: 8.4rem;
  color: $white;
  text-decoration: none;

  &.flexible {
    width: 100%;
  }

  &.dark {
    .text-container {
      color: $dark;
    }
  }

  .img-container {
    flex-shrink: 0;
    width: 8.4rem;
    height: 8.4rem;
    margin-right: 3rem;
    overflow: hidden;
    background: rgba(#000, 0.2);
    border-radius: 4.2rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .text-container {
    text-align: left;

    .name {
      margin-bottom: 0.2rem;
      font-size: 1.6rem;
      font-weight: bold;
      line-height: 2.1rem;
      word-break: break-all;
    }

    .points {
      font-size: 1.4rem;
      font-weight: 300;
      line-height: 1.8rem;
      opacity: 0.5;
    }
  }
}

@media screen and (max-width: 430px) {
  .waper-item {
    width: 30rem;
  }
}
</style>
